<template>
  <div class="authWrapper new-login-wrapper rest-password-container">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/verify-identity"> <h6 class="login-highlight">Back</h6></router-link>
            <div class="rep-icon-login">
              <img
              src="../../assets/images/member-login.svg"
                  alt="image-fluid"
              />
            </div>
            <h4 class="login-title mb-2">Reset Password OTP  </h4>
            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(changePassword)">
                  <ValidationProvider rules="required"
                                      name="New Password"
                                      vid="newpassword">
                    <b-form-group
                        label="New Password"
                        label-for="input-1"
                        slot-scope="{ valid, errors }"
                        class="mb-0"
                    >
                      <div
                          class="changeForm-group errorIcon_eye position-relative"
                      >
                        <b-form-input
                            class="no-bg-icon"
                            id="input-1"
                            :type="newPasswordType"
                            v-model="newpassword"
                            :state="errors[0] || formErrorFlag ? false : valid ? true : null"
                            placeholder="Enter your new password"
                            @input="onPasswordInput"
                        ></b-form-input>
                        <eye-form-button
                            id="newpassword"
                            hideOnDefault="false"
                            :value="newpassword"
                            class="rest-toggle-eye-icon"
                            type="text"
                            @toggle="toggleNewPasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div>
                            {{ errors[0] }}
                          </div>
                          <div class="error_message" v-if="formErrorFlag == true">
                            {{ formErrors["error"] }}
                          </div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>

                  <b-form-group label=" " label-for="" class="mb-0">
                    <div>
                      <password-strength-bar
                          @updateScore="setPasswordScore"
                          :password="newpassword"
                      ></password-strength-bar>
                    </div>
                  </b-form-group>

                  <ValidationProvider
                      rules="required|confirmed:newpassword"
                      name="Re-Type New Password"
                  >
                    <b-form-group
                        label="Re-Type New Password"
                        label-for="input-2"
                        slot-scope="{ valid, errors }"
                    >
                      <div
                          class="changeForm-group position-relative"
                          :class="errors[0] || valid ? 'errorIcon_eye' : ''"
                      >
                        <b-form-input
                            class="no-bg-icon"
                            id="input-2"
                            :type="reTypePasswordType"
                            :state="errors[0] || formErrorFlag ? false : valid ? true : null "
                            v-model="confirmpassword"
                            placeholder="Re-Type New Password"
                        ></b-form-input>
                        <eye-form-button
                            id="reTypepassword"
                            hideOnDefault="false"
                            :value="confirmpassword"
                            class="rest-toggle-eye-icon"
                            type="text"
                            @toggle="toggleReTypePasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div>
                            {{ errors[0] }}
                          </div>
                          <div class="error_message" v-if="formErrorFlag == true">
                            {{ formErrors["error"] }}
                          </div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                  <button
                      :disabled="verifyLoader"
                      class="submit-btn mt-3 next-btn ml-0"
                      type="submit"
                  >
                    <b-spinner v-if="verifyLoader" small></b-spinner>
                    Change Password
                  </button>
                </b-form>
              </ValidationObserver>
            </div>
            <!-- <submit-issue /> -->
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
// import axios from "axios";
import Api from "@/resource/MemberApi";
import {mapGetters} from "vuex";
import helper from "@/resource/Helper";
import PasswordStrengthBar from "./PasswordStrengthBar.vue";
// import EyeFormButton from "../../components/form/EyeFormButton.vue";
import EyeFormButton from "../../components/form/EyeFormButton.vue";
// import SubmitIssue from "./SubmitIssue";
export default {
  name: "ResetPassword",
  components: {
    // SubmitIssue,
    Logincarsoule,
    PasswordStrengthBar,
    EyeFormButton
  },
  data() {
    return {
      loader: false,
      newpassword: "",
      confirmpassword: "",
      formErrorFlag: false,
      formErrors: [],
      verifyLoader: false,
      passwordScore: 0,
      newPasswordType: 'password',
      isNewPasswordVisible: true,
      reTypePasswordType: 'password',
      isReNewPasswordVisible: true,
    
    };
  },
  methods: {
    toggleNewPasswordVisibility() {
      this.isNewPasswordVisible = !this.isNewPasswordVisible;
      this.newPasswordType = this.isNewPasswordVisible ? "text" : "password";
    },
    toggleReTypePasswordVisibility () {
      this.isReNewPasswordVisible = !this.isReNewPasswordVisible;
      this.reTypePasswordType = this.isReNewPasswordVisible ? "text" : "password";
    },
    changePassword() {
      if (this.passwordScore < 60) {
        this.formErrorFlag = true;
        this.formErrors["error"] = "Please use strong password.";
        return;
      }
      if (helper.validatePassword(this.newpassword) == false) {
        this.formErrorFlag = true;
        this.formErrors["error"] =
            "Password should be 8 characters long and contain at least 1 uppercase,1 lowercase, number & special character.";
        return;
      }
      this.verifyLoader = true;
      let url = 'v2/auth/set-new-password';
      let app = this;
      Api
          .post(url, {
            password: this.newpassword,
            reset_code: this.otp
          })
          .then(function(response) {
            if (response.data.status == "success") {
              helper.infoMessage(
                  app,
                  response.data.status,
                  response.data.message
              );
              helper.delayRedirect("Login", 0);
            }
          })
          .catch(function(error) {
            helper.infoMessage(app, error.data.status, error.data.message);
          })
          .finally(() => {
            this.verifyLoader = false;
          });
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
    onPasswordInput(value) {
      if (value && value.length > 3) {
        this.formErrorFlag = false;
      }
      this.resetErrorMsg();
    },
    resetErrorMsg () {
      let app = this
      if (app.formErrorFlag) {
        app.formErrorFlag = false
        app.formErrors["error"] = ''
      }
    }
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      email: "repEmail",
      otp: "OTPCode",
    }),
  },
  created(){
    console.log(this.$store.getters)
  }
  /*  created() {
      if (!this.email || !this.otp) {
        this.$router.push({ name: "ForgotPassword" });
      }
    },*/
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */

.rest-password-container .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.rest-password-container .error-message {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}


</style>

<style scoped>
.no-bg-icon {
  background: none !important;
}

.rest-toggle-eye-icon{
  position:absolute;
  top:5px;
  right:8px;
  cursor: pointer;
}
</style>